import {UyapRequest} from "./UyapRequest";

export default class SetCookie extends UyapRequest<any, any> {
    delayTime = 0;

    /**
     * Yerel kabuk ucu (UYAP'a gitmez): engel kapısından muaf. `protected` yazılmaz: bu dosya icrapro-app ESLint'inde
     * (babel-eslint) bugün ayrıştırılabiliyor, TS'e özgü anahtar sözcük onu lint dışı bırakırdı; alt sınıf korumalı
     * üyeyi herkese açık yapabilir (TS izin verir).
     */
    engelKapisindenMuaf(): boolean {
        return true;
    }

    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Cookie ayarlanıyor...";
    }


    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: ""
        };
    }

    getMockResponse(): any {
        return [];
    }

    getUrl(): string {
        return this.talepData.url;
    }

    async parse(data: string): Promise<any> {
        return data
    }
}
